'use client';
import { Container, Grid } from '@mui/material';
import { CatalogProvider } from '../../../components/ContextCatalog';
import dynamic from 'next/dynamic';

const FilterCategoryProduct = dynamic(
	() =>
		import('@negotium/componentsCustomer').then(
			(module) => module.FilterCategoryProduct
		),
	{ ssr: false }
);

export default function RootLayout({
	children,
	params: { lng },
}: {
	children: React.ReactNode;
	params: {
		lng: 'es' | 'en';
	};
}) {
	return (
		<CatalogProvider>
			<Container maxWidth='xl' sx={{ marginY: '4vh' }}>
				<Grid container spacing={4}>
					<Grid item md={3} xs={12}>
						<FilterCategoryProduct lng={lng} />
					</Grid>
					<Grid item md={9} xs={12}>
						{children}
					</Grid>
				</Grid>
			</Container>
		</CatalogProvider>
	);
}
